import { buildClient } from '../utils/url';
var actService = {
    baseUrl: {
        SERVICE: 'act',
        ACTION_AREAS: 'action-areas',
        CLIMATE_ACTIONS: 'climate-actions',
        INQUIRIES: 'inquiries',
        FORECAST_CONFIGS: 'forecast-configs',
        FORECASTS: 'forecasts',
        SOLUTIONS: 'solutions',
        TARGETS: 'targets',
        TARGET_TEMPLATES: 'target-templates',
        ORDERS: 'orders',
        BUDGETS: 'budgets',
        GRAPHS: 'graphs',
        OVERVIEW_VALUES: 'overview-values',
        STRATEGY_BUILDER: 'strategy-builder',
    },
    actionAreas: {
        GET_MANY: '/',
    },
    climateActions: {
        GET_MANY: '/',
        GET_ONE: '/:id',
        CREATE: '/',
        UPDATE_ONE: '/:id',
        DELETE_ONE: '/:id',
    },
    graphs: {
        GET_WATERFALL_GRAPH: '/waterfall-graph',
        GET_COST_GRAPH: '/cost-graph',
        GET_CONSOLIDATED_GRAPH: '/consolidated-graph',
        GET_CLIMATE_ACTIONS_GRAPH_DATA: '/climate-actions/:type',
        GET_HISTORICAL_EMISSIONS_GRAPH_DATA: '/historical-emissions',
        GET_FORECAST_GRAPH_DATA: '/forecast',
    },
    inquiries: {
        GET_MANY: '/',
        GET_ONE: '/:id',
        CREATE: '/',
        UPDATE_ONE: '/:id',
        DELETE_ONE: '/:id',
    },
    forecasts: {
        CALLBACK: '/callback',
        INVALIDATE: '/invalidate',
    },
    forecastConfigs: {
        CREATE_CONFIG: '/',
        GET_SCENARIOS: '/scenarios',
        GET_REGIONS: '/regions',
        GET_FORECAST_UNITS: '/forecast-units',
    },
    solutions: {
        GET_MANY: '/',
        GET_ONE: '/:id',
        SEARCH: '/search',
    },
    targets: {
        GET_MANY: '/',
        GET_ONE: '/:id',
        CREATE: '/',
        UPDATE_ONE: '/:id',
        DELETE_ONE: '/:id',
        GET_BASE_YEAR_EMISSIONS: '/:id/base-year-emissions',
        GET_PLOT: '/plot',
    },
    targetTemplates: {
        GET_MANY: '/',
        GET_ONE: '/:id',
        CREATE: '/',
        UPDATE_ONE: '/:id',
        DELETE_ONE: '/:id',
    },
    strategyBuilder: {
        GET_STATE: '/',
        SETUP: '/setup',
    },
    orders: {
        GET_MANY: '/',
        GET_ONE: '/:id',
        CREATE: '/',
        UPDATE_ONE: '/:id',
        DELETE_ONE: '/:id',
    },
    budgets: {
        GET_MANY: '/',
        GET_ONE: '/:id',
        CREATE: '/',
        UPDATE_ONE: '/:id',
        DELETE_ONE: '/:id',
    },
    overviewValues: {
        GET_VALUES: '/',
    },
};
var actServiceClient = {
    actionAreas: buildClient(actService.baseUrl.ACTION_AREAS, actService.actionAreas),
    climateActions: buildClient(actService.baseUrl.CLIMATE_ACTIONS, actService.climateActions),
    forecasts: buildClient(actService.baseUrl.FORECASTS, actService.forecasts),
    forecastConfigs: buildClient(actService.baseUrl.FORECAST_CONFIGS, actService.forecastConfigs),
    inquiries: buildClient(actService.baseUrl.INQUIRIES, actService.inquiries),
    solutions: buildClient(actService.baseUrl.SOLUTIONS, actService.solutions),
    targets: buildClient(actService.baseUrl.TARGETS, actService.targets),
    targetTemplates: buildClient(actService.baseUrl.TARGET_TEMPLATES, actService.targetTemplates),
    strategyBuilder: buildClient(actService.baseUrl.STRATEGY_BUILDER, actService.strategyBuilder),
    orders: buildClient(actService.baseUrl.ORDERS, actService.orders),
    budgets: buildClient(actService.baseUrl.BUDGETS, actService.budgets),
    graphs: buildClient(actService.baseUrl.GRAPHS, actService.graphs),
    overviewValues: buildClient(actService.baseUrl.OVERVIEW_VALUES, actService.overviewValues),
};
var actApiGatewayClient = {
    actionAreas: buildClient("".concat(actService.baseUrl.SERVICE, "/").concat(actService.baseUrl.ACTION_AREAS), actService.actionAreas),
    climateActions: buildClient("".concat(actService.baseUrl.SERVICE, "/").concat(actService.baseUrl.CLIMATE_ACTIONS), actService.climateActions),
    forecasts: buildClient("".concat(actService.baseUrl.SERVICE, "/").concat(actService.baseUrl.FORECASTS), actService.forecasts),
    forecastConfigs: buildClient("".concat(actService.baseUrl.SERVICE, "/").concat(actService.baseUrl.FORECAST_CONFIGS), actService.forecastConfigs),
    inquiries: buildClient("".concat(actService.baseUrl.SERVICE, "/").concat(actService.baseUrl.INQUIRIES), actService.inquiries),
    solutions: buildClient("".concat(actService.baseUrl.SERVICE, "/").concat(actService.baseUrl.SOLUTIONS), actService.solutions),
    targets: buildClient("".concat(actService.baseUrl.SERVICE, "/").concat(actService.baseUrl.TARGETS), actService.targets),
    targetTemplates: buildClient("".concat(actService.baseUrl.SERVICE, "/").concat(actService.baseUrl.TARGET_TEMPLATES), actService.targetTemplates),
    onboarding: buildClient("".concat(actService.baseUrl.SERVICE, "/").concat(actService.baseUrl.STRATEGY_BUILDER), actService.strategyBuilder),
    orders: buildClient("".concat(actService.baseUrl.SERVICE, "/").concat(actService.baseUrl.ORDERS), actService.orders),
    budgets: buildClient("".concat(actService.baseUrl.SERVICE, "/").concat(actService.baseUrl.BUDGETS), actService.budgets),
    graphs: buildClient("".concat(actService.baseUrl.SERVICE, "/").concat(actService.baseUrl.GRAPHS), actService.graphs),
    overviewValues: buildClient("".concat(actService.baseUrl.SERVICE, "/").concat(actService.baseUrl.OVERVIEW_VALUES), actService.overviewValues),
};
export { actServiceClient, actService, actApiGatewayClient };
//# sourceMappingURL=act-service.js.map